// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"c67f2844","453":"d8438140","455":"03b642b4","977":"38f58d34"}[chunkId] + ".chunk.js";
};